/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const linkedin = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#linkedin_svg__a)">
      <path
        fill="#000"
        d="M3.974 14.667v.75a.75.75 0 0 0 .75-.75h-.75Zm-2.92 0h-.75c0 .415.335.75.75.75v-.75Zm0-8.512v-.75a.75.75 0 0 0-.75.75h.75Zm2.92 0h.75a.75.75 0 0 0-.75-.75v.75Zm5.172 8.512v.75a.75.75 0 0 0 .75-.75h-.75Zm-3.071 0h-.75c0 .415.336.75.75.75v-.75Zm0-8.512v-.75a.75.75 0 0 0-.75.75h.75Zm3.071 0h.75a.75.75 0 0 0-.75-.75v.75Zm0 .959h-.75a.75.75 0 0 0 1.236.571l-.486-.571Zm2.573-.965V5.4h-.01l.01.75Zm3.228 8.518v.75a.75.75 0 0 0 .75-.75h-.75Zm-3.228 0h-.75c0 .415.336.75.75.75v-.75Zm0-4.486-.75-.004v.004h.75Zm-1.286-1.296v.75-.75Zm-6.459 5.032h-2.92v1.5h2.92v-1.5Zm-2.17.75V6.155h-1.5v8.512h1.5Zm-.75-7.762h2.92v-1.5h-2.92v1.5Zm2.17-.75v8.512h1.5V6.155h-1.5Zm5.172 4.026v4.486h1.5v-4.486h-1.5Zm.75 3.736H6.075v1.5h3.071v-1.5Zm-2.321.75V6.155h-1.5v8.512h1.5Zm-.75-7.762h3.071v-1.5H6.075v1.5Zm2.321-.75v.959h1.5v-.959h-1.5Zm1.236 1.53a3.307 3.307 0 0 1 2.097-.786l-.02-1.5a4.807 4.807 0 0 0-3.048 1.143l.97 1.143Zm2.087-.786c.753 0 1.338.272 1.75.771.425.516.728 1.354.728 2.583h1.5c0-1.458-.359-2.673-1.07-3.537-.727-.88-1.755-1.317-2.908-1.317v1.5Zm2.478 3.354v4.414h1.5v-4.414h-1.5Zm.75 3.664h-3.228v1.5h3.228v-1.5Zm-2.478.75v-4.486h-1.5v4.486h1.5Zm-2.036-6.532c-1.124 0-2.037.947-2.037 2.046h1.5c0-.29.26-.546.537-.546v-1.5Zm2.036 2.05c.005-1.106-.912-2.05-2.036-2.05v1.5c.282 0 .537.257.536.542l1.5.007ZM3.153 2.758a.675.675 0 0 1-.675.675v1.5a2.175 2.175 0 0 0 2.175-2.175h-1.5Zm-.675.675a.675.675 0 0 1-.675-.675h-1.5c0 1.201.974 2.175 2.175 2.175v-1.5Zm-.675-.675c0-.373.302-.675.675-.675v-1.5A2.175 2.175 0 0 0 .303 2.759h1.5Zm.675-.675c.373 0 .675.302.675.675h1.5A2.175 2.175 0 0 0 2.478.584v1.5Z"
      />
    </g>
    <defs>
      <clipPath id="linkedin_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default linkedin
